module.exports = __webpack_public_path__ + "static/media/p1.55b3427e.png";